import * as React from 'react';
import { DeleteIcon } from 'src/assets/icons';
import { P14 } from '../../Typography';
import { IconButton } from '../../IconButton';
import { StyledAcceptedFileItem } from './AcceptedFileItem.styled';

export interface AcceptedFileItemProps {
  file: File;
  onDelete: () => void;
}

export const AcceptedFileItem: React.FunctionComponent<AcceptedFileItemProps> = ({ file, onDelete }) => {
  return (
    <StyledAcceptedFileItem>
      <P14>{file.name}</P14>
      <IconButton onClick={onDelete}>
        <DeleteIcon size={15} />
      </IconButton>
    </StyledAcceptedFileItem>
  );
};
